
export class ProjectsDto {
    projectId?: number;
    projectCode:string;
    projectName: string;
    projectDescription: string;
    costCenterId?: number;
    stateId?: number;
    otType: string;
    location: string;
    latitude: string;
    longitude: string;
    isActive: boolean;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;
  status: boolean;
}

export const ProjectDtoDefault : ProjectsDto = {
    projectId: 0,
    projectCode:"",
    projectName: "",
    projectDescription: "",
    costCenterId: 1,
    stateId: 1,
    otType: "",
    location: "",
    latitude: "",
    longitude: "",
    status: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt : new Date() ,
    updatedUser : 0,
    versionFlag : 1,
    isActive: true

};

